<div class="dtf-accountdetails">
  <!--Announcement Banner Code-->
  <div class="dtf-alertpage"></div>


  <div *ngIf="(this.bodyLoaded)" class="mbfs-payoff-quote-spinner">

    <!--Default page to load while waiting for Redirection to Classic-->
    <section class="mbfs-home-hero"
      style="background-image: url(/static/assets/img/dtf-assets/images/redesign/mbfs_top_image_and_tint.jpg);">
      <section class="mbfs-home-hero__header">
        <h2 class="mbfs-home-hero__header-subtitle">
          {{ 'LoaderPages.BannerHeader' | translate }}
        </h2>
        <p class="mbfs-home-hero__header-text-demi">
          {{ 'LoaderPages.Loading' | translate }}
        </p>

        <!--Spinner-->
        <div class="mbfs-loading-spinner-overlay"></div>
        <div class="mbfs-loading-spinner"> </div>
      </section>
    </section>
  </div>

   <div class="container_dashboard" *ngIf="!this.bodyLoaded && !isCanadaPortal">
    <!-- <h4 class="dtfbrochures__header_dark" style=" padding-left: 41px;">{{ 'Dashboard.ProfileHeader' | translate }}</h4>
    <br> -->
    <!-- <p style=" padding-left: 41px;">{{ 'Dashboard.link' | translate }}</p> -->
      <div class="dtfbrochures__containerlong">
          <div class="row4">
            <div class="dynamicflexbox">
              <section class="section">
                <div class="section__item section__item--start">
                  <h4 class="dtfbrochures__header5">{{ 'Dashboard.NumAccounts' | translate }}</h4>
                  <h3 class="dtfbrochures__header6">{{this.recAccCount}}</h3>
                </div>
                <div class="section__item section__item--end">
                  <h4 class="dtfbrochures__header5">{{ 'Dashboard.CurrentDue' | translate }}</h4>
                  <h3 class="dtfbrochures__header6">${{this.totalDue}}</h3>
                </div>
              </section>
            </div>
          </div>
        </div>
    </div>
    
  <div class="container_dashboard">
    <div class="dtf-dashboard" style="padding-top: 41px; padding-bottom: 21px;">
      <div *ngIf="!trans_history">
      <h1 style="margin-left: 5%;">Make Payment</h1>
      <div class="example-button-row">
        <mat-button-toggle-group [hideSingleSelectionIndicator]="true" [value]="selectedState" (change)="onChangeButton($event)">
          <mat-button-toggle  [value]="toggleEnum.Option0">Online Payment</mat-button-toggle>
          <mat-button-toggle  [value]="toggleEnum.Option1">Principal Payment</mat-button-toggle>
          <mat-button-toggle  [value]="toggleEnum.Option3">Statement Payment</mat-button-toggle>
          <mat-button-toggle  [value]="toggleEnum.Option6">Recurring Payment</mat-button-toggle>
          <mat-button-toggle  [value]="toggleEnum.Option4">Manage Bank Profile</mat-button-toggle>
          <mat-button-toggle  [value]="toggleEnum.Option2">Payment History</mat-button-toggle>
        </mat-button-toggle-group>
        </div>
    </div>
    
    <div *ngIf="trans_history">
     <h1 style="margin-left: 5%;">Online Transaction History</h1>
      <div class="example-button-row">
      <mat-button-toggle-group [hideSingleSelectionIndicator]="true" [value]="selectedState" (change)="onChangeButton($event)">
      <mat-button-toggle  [value]="toggleEnum.Option2">Online Transaction History</mat-button-toggle>   
      <mat-button-toggle  [value]="toggleEnum.Option5">Statement Payment History</mat-button-toggle>
      <mat-button-toggle  [value]="toggleEnum.Option7">Recurring Payment History</mat-button-toggle>
      <mat-button-toggle  [value]="toggleEnum.Option8">Help</mat-button-toggle>
      </mat-button-toggle-group>
    </div>
  </div>
    <div class="container_dashboard">
      <div class="mbfs-contact-us-page-inner" style="padding-top: 21px; padding-bottom: 15px; padding-left: 21px;">
        <div *ngIf="(!this.tableLoaded)" class="mbfs-payoff-quote-spinner" style="margin-bottom: 20px;">
            <!--Spinner on Login Load-->
            <div class="demo-container">
              <span>{{ 'Invoice.Loading' | translate }}</span>
              <div class="progress-bar">
                <div class="progress-bar-value"></div>
              </div>
            </div>
            <br>
        </div> 
        <div *ngIf="(this.tableLoaded)">
          <div *ngIf="make_payment">
            <iframe id='olpframe' style="height: 800px; width: 110%; overflow:hidden;" [src]="olpredirecturl"></iframe>
          </div>
        </div>
       </div>
      </div>
    </div>
  </div>

     <!-- <router-outlet></router-outlet> -->

</div>